//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QuestionMark from '~/static/question-mark.svg';
import BlackFridayLogo from '~/static/blackfriday.svg';

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      BlackFridayLogo,
      QuestionMark,
    };
  },
  methods: {
    select(event) {
      this.$emit('input', event.target.checked);
    },
  },
};
